import React from 'react'
import serverData from 'ppbl/utils/server-data'
import DOMPurify from 'dompurify'

export default function CookieBanner() {
  if (!serverData.data?.cookieBannerInfo) return null
  const { css: dirtyCss, html: dirtyHtml } = serverData.data.cookieBannerInfo

  const sanitizedHTML = DOMPurify.sanitize(dirtyHtml)
  const sanitizedCss = DOMPurify.sanitize(dirtyCss, {
    FORCE_BODY: true,
    ADD_TAGS: ['style'],
  })

  return (
    <div
      dangerouslySetInnerHTML={{ __html: `${sanitizedCss}${sanitizedHTML}` }}
    />
  )
}
